import { mq } from 'util/dom/mq';
import translateFilter from 'framework/filters/translate';

const cantonRouteFragment = translateFilter('COLLECTION_POINTS_APP.ROUTE_FRAGMENTS.CANTON');
const collectionPointRouteFragment = translateFilter('COLLECTION_POINTS_APP.ROUTE_FRAGMENTS.COLLECTION_POINTS');

const COLLECTION_POINTS_RECORD_NAMES = Object.freeze({
    MAP: 'MAP',
    CANTON_DETAIL: 'CANTON_DETAIL',
    LOCATION_DETAIL: 'LOCATION_DETAIL',
});
const { MAP, CANTON_DETAIL, LOCATION_DETAIL } = COLLECTION_POINTS_RECORD_NAMES;

const COLLECTION_POINTS_RECORDS = {
    'collection-points-app': {
        routes: [
            {
                component: 'collection-points-page',
                name: LOCATION_DETAIL,
                path: `/${ collectionPointRouteFragment }/:entry/`,
                meta: {
                    scrollBehavior(to, from) {
                        const isMobile = mq('<=sm');
                        const hasFromLocation = from.matched.length;

                        if (!isMobile && hasFromLocation) {
                            return {};
                        }

                        return { x: 0, y: 0 };
                    },
                },
            },
            {
                component: 'collection-points-page',
                name: CANTON_DETAIL,
                path: `/${ cantonRouteFragment }/:canton/`,
                meta: {
                    scrollBehavior() {
                        return { x: 0, y: 0 };
                    },
                },
            },
            {
                component: 'collection-points-page',
                name: MAP,
                path: '/:search?/',
                meta: {
                    scrollBehavior(to, from) {
                        const isMobile = mq('<=sm');
                        const sameOriginRoute = from.matched.find(m => m.name === MAP);

                        if (!isMobile || sameOriginRoute) {
                            return {};
                        }

                        return { x: 0, y: 0 };
                    },
                },
            },
            {
                redirect: { name: MAP },
                path: '/*',
            },
        ],
    },
};

export {
    COLLECTION_POINTS_RECORD_NAMES,
    COLLECTION_POINTS_RECORDS as default,
};
